"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lendingPool_1 = __importDefault(require("./lendingPool"));
const offchainAccountLendingVault_1 = __importDefault(require("./offchainAccountLendingVault"));
class OffchainAccount {
    constructor(offchain, account) {
        this.getOnchain = () => this.offchain;
        this.getAccountAddress = () => this.accountAddress;
        this.offchain = offchain;
        this.accountAddress = account;
        this.lendingPools = {};
        this.lendingVaults = {};
    }
    initializeLendingPool(factory, pair) {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPool = yield this.offchain.getLendingPool(factory, pair);
            return new lendingPool_1.default(this, lendingPool);
        });
    }
    getLendingPool(factory, pair) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.lendingPools[factory])
                this.lendingPools[factory] = {};
            const lendingPoolsOfFactory = this.lendingPools[factory];
            if (!lendingPoolsOfFactory[pair])
                lendingPoolsOfFactory[pair] = this.initializeLendingPool(factory, pair);
            return lendingPoolsOfFactory[pair];
        });
    }
    initializeLendingVault(vaultAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingVault = yield this.offchain.getLendingVault(vaultAddress);
            return new offchainAccountLendingVault_1.default(this, lendingVault);
        });
    }
    getLendingVault(vaultAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.lendingVaults[vaultAddress])
                this.lendingVaults[vaultAddress] = this.initializeLendingVault(vaultAddress);
            return this.lendingVaults[vaultAddress];
        });
    }
    getUserData() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.offchain.getUserData(this.accountAddress);
        });
    }
    getLendingVaultsUserData() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.offchain.getLendingVaultsUserData(this.accountAddress);
        });
    }
    getBorrowPositions() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = {};
            const userData = yield this.getUserData();
            if (userData === null)
                return result;
            for (const factory in userData) {
                result[factory] = Object.keys(userData[factory].collateralPositions);
            }
            return result;
        });
    }
    getSupplyPositions() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = {};
            const userData = yield this.getUserData();
            if (userData === null)
                return result;
            for (const factory in userData) {
                result[factory] = Object.keys(userData[factory].supplyPositions);
            }
            return result;
        });
    }
    getLendingVaultsSuppliedUSD() {
        return __awaiter(this, void 0, void 0, function* () {
            let suppliedUSD = 0;
            const lendingVaultUserData = yield this.getLendingVaultsUserData();
            if (lendingVaultUserData === null)
                return 0;
            for (const address in lendingVaultUserData) {
                const lendingVault = yield this.getLendingVault(address);
                suppliedUSD += yield lendingVault.getValue();
            }
            return suppliedUSD;
        });
    }
    getLendingVaultsEarningsUSD() {
        return __awaiter(this, void 0, void 0, function* () {
            let earningsUSD = 0;
            const lendingVaultUserData = yield this.getLendingVaultsUserData();
            if (lendingVaultUserData === null)
                return 0;
            for (const address in lendingVaultUserData) {
                const lendingVault = yield this.getLendingVault(address);
                earningsUSD += yield lendingVault.getEarningsUSD();
            }
            return earningsUSD;
        });
    }
    getLendingVaultsYearlyYieldUSD() {
        return __awaiter(this, void 0, void 0, function* () {
            let yieldUSD = 0;
            const lendingVaultUserData = yield this.getLendingVaultsUserData();
            if (lendingVaultUserData === null)
                return 0;
            for (const address in lendingVaultUserData) {
                const lendingVault = yield this.getLendingVault(address);
                yieldUSD += (yield lendingVault.getValue()) * (yield lendingVault.getPoolToken().getSupplyAPR());
            }
            return yieldUSD;
        });
    }
}
exports.default = OffchainAccount;
